module.exports = __webpack_public_path__ + "static/media/bost logo.07229c27.png";